import Vue from 'vue'
import TreeItem from '@/components/tree/Tree-item.vue'

Vue.component('tree-item', TreeItem)

export default {
    name: 'Menu',
    data () {
        return {
            bus: new Vue(),
        }
    },
    created() {
        this.bus.$on('select', model => {
            this.$emit('select', model);
        })

        this.bus.$on('update', () => {
            Vue.nextTick(() => {
                this.$emit('update');
            })
        })
    },
    props: {
        data: {
            type: Array,
            required: true
        },
        root: {
            type: [Number, String],
            default: null,
        },
        value: {
            type: [Number, String],
            default: null,
        },
        search: {
            type: String,
            default: '',
        },
        notHierarchy: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        tree() {
            let tree = []
            this.data.forEach(item => {
                let sorted = _.sortBy(item.children, map => {
                    return map.parent
                }).map(m => {
                    return { ...m, root: item.value, children: [] }
                })
                let treeList = []
                let lookup = {}

                sorted.forEach(obj => {
                    if (!this.notHierarchy) {
                        lookup[obj.value] = obj
                    } else {
                        tree.push(obj)
                    }
                })
                if (!this.notHierarchy) {
                    sorted.forEach(obj => {
                        if (obj.parent !== 0) {
                            lookup[obj.parent].children.push(obj)
                        } else {
                            treeList.push(obj)
                        }
                    })
                    tree.push({
                        children: treeList,
                        value: null,
                        name: item.name,
                        root: item.value,
                    })
                }
                
            })
            return tree
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/tree/tree.js